module.exports = __webpack_public_path__ + "img/N339-2.28f712a4.png";